import { HostedContentFilterPolicy_SchemaData } from '../../../../../models/baseline-schemas/hosted-content-filter-policy.schema';
import { updateExoHostedContentFilterPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/hosted-content-filter-policy/actions';
import { HostedContentFilterPolicy } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/hosted-content-filter-policy/model';

export const PolicyName = 'Default';

export function Remediate(_tenant: string, data: HostedContentFilterPolicy[], schema: any) {
    const props: HostedContentFilterPolicy_SchemaData = schema.contains.properties;

    const spamAction = props.SpamAction.const;
    const highConfidenceSpamAction = props.HighConfidenceSpamAction.const;
    const phishSpamAction = props.PhishSpamAction.const;
    const highConfidencePhishAction = props.HighConfidencePhishAction.const;
    const bulkSpamAction = props.BulkSpamAction.const;

    const actions = [spamAction, highConfidenceSpamAction, phishSpamAction, highConfidencePhishAction, bulkSpamAction];

    const item: Partial<HostedContentFilterPolicy> = {
        // Identity,
        Identity: 'Default',
        // Bulk Email Threshold
        BulkThreshold: props.BulkThreshold.const,
        // Increase Spam Score
        IncreaseScoreWithImageLinks: props.IncreaseScoreWithImageLinks.const,
        IncreaseScoreWithNumericIps: props.IncreaseScoreWithNumericIps.const,
        IncreaseScoreWithRedirectToOtherPort: props.IncreaseScoreWithRedirectToOtherPort.const,
        IncreaseScoreWithBizOrInfoUrls: props.IncreaseScoreWithBizOrInfoUrls.const,

        // Mark as Spam
        MarkAsSpamEmptyMessages: props.MarkAsSpamEmptyMessages.const,
        MarkAsSpamEmbedTagsInHtml: props.MarkAsSpamEmbedTagsInHtml.const,
        MarkAsSpamJavaScriptInHtml: props.MarkAsSpamJavaScriptInHtml.const,
        MarkAsSpamFormTagsInHtml: props.MarkAsSpamFormTagsInHtml.const,
        MarkAsSpamFramesInHtml: props.MarkAsSpamFramesInHtml.const,
        MarkAsSpamWebBugsInHtml: props.MarkAsSpamWebBugsInHtml.const,
        MarkAsSpamObjectTagsInHtml: props.MarkAsSpamObjectTagsInHtml.const,
        MarkAsSpamSensitiveWordList: props.MarkAsSpamSensitiveWordList.const,
        MarkAsSpamSpfRecordHardFail: props.MarkAsSpamSpfRecordHardFail.const,
        MarkAsSpamFromAddressAuthFail: props.MarkAsSpamFromAddressAuthFail.const,
        MarkAsSpamNdrBackscatter: props.MarkAsSpamNdrBackscatter.const,
        EnableLanguageBlockList: props.EnableLanguageBlockList.const,
        ...(props.EnableLanguageBlockList.const === true &&
            props.LanguageBlockList?.items?.enum?.length > 0 && {
                LanguageBlockList: props.LanguageBlockList.items.enum,
            }),
        EnableRegionBlockList: props.EnableRegionBlockList.const,
        ...(props.EnableRegionBlockList.const === true &&
            props.RegionBlockList?.items?.enum?.length > 0 && {
                RegionBlockList: props.RegionBlockList.items.enum,
            }),
        TestModeAction: props.TestModeAction.const,
        ...(props.TestModeAction.const === 'BccMessage' &&
            props.TestModeBccToRecipients?.items?.enum?.length > 0 && {
                TestModeBccToRecipients: props.TestModeBccToRecipients.items.enum,
            }),

        // Actions
        SpamAction: spamAction,
        ...(spamAction === 'Quarantine' && {
            SpamQuarantineTag: props.SpamQuarantineTag.const,
        }),
        HighConfidenceSpamAction: highConfidenceSpamAction,
        ...(highConfidenceSpamAction === 'Quarantine' && {
            HighConfidenceSpamQuarantineTag: props.HighConfidenceSpamQuarantineTag.const,
        }),
        PhishSpamAction: phishSpamAction,
        ...(phishSpamAction === 'Quarantine' && {
            PhishQuarantineTag: props.PhishQuarantineTag.const,
        }),
        HighConfidencePhishAction: highConfidencePhishAction,
        ...(highConfidencePhishAction === 'Quarantine' && {
            HighConfidencePhishQuarantineTag: props.HighConfidencePhishQuarantineTag.const,
        }),
        BulkSpamAction: bulkSpamAction,
        ...(bulkSpamAction === 'Quarantine' && {
            BulkQuarantineTag: props.BulkQuarantineTag.const,
        }),
        IntraOrgFilterState: props.IntraOrgFilterState.const,
        QuarantineRetentionPeriod: props.QuarantineRetentionPeriod.const,
        ...(actions.includes('AddXHeader') && {
            AddXHeaderValue: props.AddXHeaderValue.const,
        }),
        ...(actions.includes('ModifySubject') && {
            ModifySubjectValue: props.ModifySubjectValue.const,
        }),
        ...(actions.includes('Redirect') && {
            RedirectToRecipients: props.RedirectToRecipients.items?.const,
        }),
        InlineSafetyTipsEnabled: props.InlineSafetyTipsEnabled.const,
        PhishZapEnabled: props.PhishZapEnabled.const,
        SpamZapEnabled: props.SpamZapEnabled.const,

        // Allowed and Blocked Senders and Domains
        AllowedSenders: props.AllowedSenders.items?.enum || [],
        AllowedSenderDomains: props.AllowedSenderDomains.items?.enum || [],
        BlockedSenders: props.BlockedSenders.items?.enum || [],
        BlockedSenderDomains: props.BlockedSenderDomains.items?.enum || [],
    };

    return updateExoHostedContentFilterPolicy({ _tenant, data: item });
}
